import type { Run } from '../run';

/**
 * A simple "competent driver" used by headless tests and the browser bot playtest.
 * On the ground it drives, easing off to avoid wheelies; in the air it levels the buggy to the
 * slope of the landing zone. It reads only sim state, so its runs are deterministic.
 */
export function botThrottle(run: Run): number {
  const r = run.readout;
  const grounded = r.wheelGrounded[0] || r.wheelGrounded[1];
  const slopeAhead = run.terrain.slopeAt(r.x + 2.5);
  const targetAngle = Math.atan(slopeAhead);
  const error = targetAngle - r.angle;
  if (grounded) {
    if (error < -0.55) return 0.15; // nose too high: back off before flipping over
    return 1;
  }
  const command = error * 2.2 - r.angularVelocityZ * 0.35;
  return Math.max(-1, Math.min(1, command));
}
